<template>
  <v-container class="page-content-wrapper pt-0 px-sm-3">
    <h1 class="headline pa-3 px-sm-5">{{ $t("accounts") }}</h1>
    <v-card class="flex-grow-1 d-flex flex-column">
      <v-data-table
        ref="dataTable"
        :class="{
          'full-height-table flex-grow-1 pt-0 d-flex flex-column': !isMobile,
          'mobile-table': isMobile,
        }"
        :headers="tableHeaders"
        :items="tableItems"
        :loading="loadingTableData"
        item-key="accountID"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
        must-sort
        fixed-header
        hide-default-footer
        disable-pagination
        @update:sort-by="scrollTabletoTop"
        @update:sort-desc="scrollTabletoTop"
      >
        <template #item.has2FA="{ item }">
          <v-icon v-if="item.has2FA" color="success">$checkmark</v-icon>
        </template>
        <template #item.userName="{ item }">
          <span class="text-break-all"> {{ item.userName }}</span>
        </template>
        <template #item.accountStatus="{ item }">
          {{
            $t(
              getObjectTextByPropVal(
                item.accountStatus,
                $options.accountStatusStates,
                "id",
                "key"
              )
            )
          }}
        </template>
        <template #item.accessType="{ item }">
          {{
            $t(
              getObjectTextByPropVal(
                item.accessType,
                $options.accessTypes,
                "id",
                "key"
              )
            )
          }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { axiosGet } from "@/api/requests";
import handleErrorStatus from "@/mixins/handleErrorStatus";
import dataTableDefaults from "@/mixins/dataTableDefaults";
import snackBarMessages from "@/mixins/snackBarMessages";

import { accountStatusStates, accessTypes } from "@/static/staticData";
import { getObjectTextByPropVal } from "@/helpers/arrayHelpers";

export default {
  title: "accounts",
  name: "AccountsOverview",
  accountStatusStates: accountStatusStates,
  accessTypes: accessTypes,
  mixins: [dataTableDefaults, snackBarMessages, handleErrorStatus],
  data() {
    return {
      loadingTableData: true,
      sortBy: "name",
      descending: false,
      tableItems: [],
    };
  },
  computed: {
    tableHeaders() {
      return [
        {
          text: this.$t("name"),
          value: "name",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("userName"),
          value: "userName",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("accessType"),
          value: "accessType",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("status"),
          value: "accountStatus",
          divider: true,
          sortable: true,
        },
        {
          text: this.$t("has2FA"),
          value: "has2FA",
          divider: true,
          sortable: true,
          width: 80,
        },
      ];
    },
    ...mapState(["currentHotel", "user", "connection"]),
  },
  watch: {
    currentHotel(val) {
      if (val !== null) {
        this.getTableItems();
      }
    },
  },
  created() {
    if (this.currentHotel) {
      this.getTableItems();
    }
  },
  methods: {
    getTableItems() {
      this.loadingTableData = true;
      const url =
        process.env.VUE_APP_IDENTITY_URL +
        "/users?accountType=2&hotelcode=" +
        this.currentHotel.hotelCode +
        "&cloudId=" +
        this.connection.id;
      axiosGet(url, this.user.authToken)
        .then((response) => {
          this.handleGetAccountsResponse(response);
        })
        .catch((error) => {
          this.snackbarError(this.$t("loadingDataFailed"));
        })
        .finally(() => {
          this.loadingTableData = false;
        });
    },
    handleGetAccountsResponse(response) {
      if (response.status && response.status !== 200) {
        this.handleErrorStatus(response.status);
      } else if (response.success) {
        this.tableItems = response.accounts;
      } else {
        this.snackbarError(this.$t("loadingDataFailed"));
      }
    },
    getObjectTextByPropVal: getObjectTextByPropVal,
  },
};
</script>
